import { Component, Input } from '@angular/core';
import { BmsjHipsterSharedCommonModule } from '../../../../../shared';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-plot-visualization-image-display',
    standalone: true,
    imports: [
        BmsjHipsterSharedCommonModule,
        NgSelectModule
    ],
    templateUrl: './plot-visualization-image-display.component.html',
    styleUrl: './plot-visualization-image-display.component.scss'
})
export class PlotVisualizationImageDisplayComponent {

    constructor(private activeModal: NgbActiveModal) {
    }

    @Input() imageUrl: string;

    cancel() {
        this.activeModal.dismiss();
    }

}
